import React from 'react'

function ForbiddenPage() {
  return <div>Forbidden Page</div>
}

export default ForbiddenPage
